/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect, useState } from "react";
import Paper from "@mui/material/Paper";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/SearchOutlined";
import LocationPin from "@mui/icons-material/FmdGoodOutlined";
import OpenIcon from "@mui/icons-material/KeyboardArrowDown";
import CloseIcon from "@mui/icons-material/KeyboardArrowUp";
import ICompAnalysis from "../../../types/ICompAnalysis";
import KochOrigin from "./KochOrigin";
import { useNitroStore } from "../../../store/Store";
import { useNitroCAStore } from "../../../store/CompetitiveAnalysisStore";

const KochOrigins = ({
  kochRecords,
  activeFreightButton,
  setActiveFreightButton,
}: {
  kochRecords: ICompAnalysis[];
  activeFreightButton: any;
  setActiveFreightButton: (value: any) => void;
}) => {
  const [open, setOpen] = useState(false);
  const [disabled, setDisabled] = useState(false);
  const [filter, setFilter] = useState("");
  const [mode] = useNitroStore((state) => [state.mode]);
  const [hiddenOrigins] = useNitroCAStore((state) => [state.hiddenOrigins]);

  useEffect(() => {
    if (!kochRecords || kochRecords.length <= 1) {
      setDisabled(true);
      setOpen(false);
    } else {
      setDisabled(false);
    }
  }, [kochRecords]);

  useEffect(() => {
    if (open) {
      // Scroll to bottom of competitor-chart
      const competitorChart = document.getElementById("koch-origins");
      competitorChart?.scrollIntoView({ behavior: "smooth" });
    }
  }, [open]);
  return (
    <div id="koch-origins">
      <Paper
        style={{
          boxShadow: "none",
          border: "1px solid #d9d9d9",
          padding: open ? "6px 10px" : "6px 10px",
          paddingBottom: open ? 10 : 6,
          display: "flex",
          flexDirection: "column",
          gap: 5,
          borderRadius: open ? 10 : 15,
          backgroundColor: disabled ? "#eee" : "white",
        }}
      >
        {/* HEADER */}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: disabled ? "default" : "pointer",
            opacity: disabled ? 0.4 : 1,
            height: 40,
          }}
          onClick={() => {
            if (disabled) return;
            setOpen(open === false);
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: 4 }}>
            <LocationPin />
            <div>Other Koch Origins</div>
          </div>

          {open ? <CloseIcon /> : <OpenIcon />}
        </div>
        {/* END HEADER */}

        {/* BODY */}
        <div
          style={{
            display: open ? "flex" : "none",
            flexDirection: "column",
            gap: 20,
            paddingTop: 0,
          }}
        >
          {/* SEARCH BAR */}
          <div style={{ padding: "0px 10px" }}>
            <TextField
              fullWidth
              InputProps={{
                sx: { borderRadius: 16, padding: "0px 8px" },
                endAdornment: (
                  <InputAdornment position="end">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
              placeholder="Search Koch origins"
            />
          </div>
          {/* END SEARCH BAR */}

          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {kochRecords.map((record, index) => {
              if (index === 0) return null; // Skip first record (main origin)

              const currentModeKey = mode === "TRUCK" ? "truck" : "rail";
              const isHiddenByMode = hiddenOrigins[currentModeKey].has(
                record.origin.name,
              );

              const isHiddenByFilter =
                !!filter &&
                !record.origin.name
                  .toLowerCase()
                  .includes(filter.toLowerCase());

              return (
                <KochOrigin
                  key={record.id}
                  record={record}
                  activeFreightButton={activeFreightButton}
                  setActiveFreightButton={setActiveFreightButton}
                  hidden={isHiddenByMode || isHiddenByFilter}
                />
              );
            })}
          </div>
        </div>

        {/* END BODY */}
      </Paper>
    </div>
  );
};

export default KochOrigins;
